import * as angular from "angular";
import {IController} from "angular";

export class ActionReasonsTableComponent implements IController {

  actionReasons: any;
  onUpdateActionReason: Function;
  onDeleteActionReason: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
  }
}

angular
  .module('bringoz.admin.action-reasons')
  .component('actionReasonsTable', {
    bindings: {
      actionReasons: '<',
      onUpdateActionReason: '&',
      onDeleteActionReason: '&'
    },
    template: require('./action-reasons-table.html').default,
    controller: ActionReasonsTableComponent
  });
